module.exports = __webpack_public_path__ + "img/logo-placeholder.bfa7c10a.svg";